module.exports = __webpack_public_path__ + "static/media/rang-moc-lech-o-tre-nho-1-1.b47fa193.jpeg";